import { Progress } from '@mantine/core';
import { Wrapper } from './LoaderBar.style';

export type LoaderBarProps = {
  isLoading: boolean;
  color: string;
};

export function LoaderBar(props: LoaderBarProps) {
  const { isLoading, color = 'pink' } = props;

  if (!isLoading) {
    return null;
  }

  return (
    <Wrapper className='LoaderBar-wrapper' data-testid='LoaderBar-wrapper'>
      <Progress value={100} animated striped color={color} />
    </Wrapper>
  );
}

export default LoaderBar;
